"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/base/buttons/button";
import { cx } from "@/utils/cx";
const ANALYZE_LABEL = "Analyze";
const ANALYZE_LOCKED_LABEL = "Analyze, requires Unilytics Pro";
export function AnalyzeButton(t0) {
  const $ = _c(7);
  const {
    onClick,
    isDisabled: t1,
    className
  } = t0;
  const isDisabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cx("px-2.5 py-1.5 text-xs", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isDisabled ? ANALYZE_LOCKED_LABEL : ANALYZE_LABEL;
  let t4;
  if ($[2] !== isDisabled || $[3] !== onClick || $[4] !== t2 || $[5] !== t3) {
    t4 = <Button type="button" color="brand" size="sm" className={t2} aria-label={t3} isDisabled={isDisabled} onClick={onClick}>{ANALYZE_LABEL}</Button>;
    $[2] = isDisabled;
    $[3] = onClick;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}